import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../../../services/token.service';
import { Meta } from '@angular/platform-browser';

@Component({
	selector: 'research-studies',
	templateUrl: 'research-studies.html',
	styleUrls: ['research-studies.scss']
})
export class ResearchStudiesComponent implements OnInit {

	constructor(
		private _tokenService: TokenService,
		private _router: Router,
		private _meta: Meta
	) {
		this._meta.updateTag({ name: 'description',
			content: 'CropManage is a crop management web application developed ' +
			'by UCANR which help farmers manage irrigation and fertilization scheduling.'})
	}

	ngOnInit(): void {
	}
}
